import { render, staticRenderFns } from "./NavCompsUcRenderer.vue?vue&type=template&id=d45be746"
import script from "./NavCompsUcRenderer.vue?vue&type=script&lang=js"
export * from "./NavCompsUcRenderer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports